module.exports = __webpack_public_path__ + "static/img/banner-01.97ddeed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/online/banner-01.jpg
// module id = DBH3
// module chunks = 13 16